/**
 * Providers who can support different behavior for fetching availabilities
 */
export enum AvailabilityMode {
  /**
   * Support fetching only days (/availabilities/day) where slots are available but no actual slots and
   * when user click on day It call /availabilities/times to fetch slots for that specific day.
   */
  PARTIAL = 'PARTIAL',
  /**
   * Doesn't support PARTIAL and always return all available slots between given date range.
   */
  NON_PARTIAL = 'NON_PARTIAL',
  /**
   * Similar to NON_PARTIAL but applies to all providers.
   */
  DEFAULT = 'DEFAULT',
}
